import atMentionsPluginTrigger from './utils/atMentionsPluginTrigger';
import createLazyPlugin, { LazyPlugin } from 'owa-editor-lazy-plugin/lib/utils/createLazyPlugin';
import { LazyModule } from 'owa-bundling';
import AtMentionPickerPlugin from './plugin/AtMentionPickerPlugin';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "HtmlEditor" */ './lazyIndex'));
export type LazyAtMentionsPickerPlugin = LazyPlugin<AtMentionPickerPlugin>;

export let LazyAtMentionsPickerPluginClass = createLazyPlugin(
    lazyModule,
    m => m.AtMentionPickerPlugin,
    'AtMentionsPicker',
    atMentionsPluginTrigger
);
